// ============================================
// MODALORIGENPRODUCTO.JS — Motor de origen Fase 1
// ============================================
// Mini-modal que aparece al pulsar "+ Agregar producto" en el cotizador.
// Pregunta DE DONDE traer el producto. Por ahora solo "La Tienda" funciona
// (ejecuta el flujo actual intacto); "Una coleccion" y "Listas pactadas"
// quedan VISIBLES pero deshabilitadas con etiqueta "Proximamente" (F2/F3).
//
// SOLO NAVEGACION: este componente no toca dinero, carrito ni backend. Al
// elegir "La Tienda" llama onElegirTienda(), que en el padre es exactamente
// agregarEnTienda() (la funcion que ya existe, sin cambios).

import React from 'react';
import { Store, Layers, Lock, X } from 'lucide-react';
import {
  PP, COLOR_OSCURO, COLOR_GRIS, COLOR_GRIS_CLARO, COLOR_BORDE,
} from './helpersClientes';
import { tokens } from '../styles/tokens';

// Una opcion del menu de origen (boton grande con icono + titulo + descripcion).
// `proximamente` la deja deshabilitada con su etiqueta.
function OpcionOrigen({ icono: Icono, titulo, descripcion, proximamente, onElegir }) {
  const deshabilitada = !!proximamente;
  return (
    <button
      type="button"
      onClick={deshabilitada ? undefined : onElegir}
      disabled={deshabilitada}
      style={{
        display: 'flex', alignItems: 'center', gap: 14, width: '100%', textAlign: 'left',
        padding: '14px 16px', borderRadius: 12, fontFamily: PP,
        border: `1px solid ${COLOR_BORDE}`, background: '#fff',
        cursor: deshabilitada ? 'default' : 'pointer',
        opacity: deshabilitada ? 0.6 : 1,
        transition: 'border-color 0.15s, box-shadow 0.15s',
      }}
      onMouseEnter={(e) => { if (!deshabilitada) { e.currentTarget.style.borderColor = tokens.primary; e.currentTarget.style.boxShadow = '0 2px 10px rgba(24,95,165,0.12)'; } }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = COLOR_BORDE; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <span style={{
        flexShrink: 0, width: 44, height: 44, borderRadius: 10,
        background: tokens.primarySoft, color: tokens.primary,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Icono size={22} strokeWidth={2} />
      </span>
      <span style={{ minWidth: 0, flex: 1 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: COLOR_OSCURO }}>{titulo}</span>
          {proximamente && (
            <span style={{
              fontSize: 10, fontWeight: 800, letterSpacing: 0.4, textTransform: 'uppercase',
              color: COLOR_GRIS_CLARO, background: tokens.surfaceSubtle,
              border: `1px solid ${COLOR_BORDE}`, borderRadius: 6, padding: '2px 6px',
            }}>Proximamente</span>
          )}
        </span>
        <span style={{ display: 'block', fontSize: 12, color: COLOR_GRIS, marginTop: 2 }}>{descripcion}</span>
      </span>
    </button>
  );
}

export default function ModalOrigenProducto({ onElegirTienda, onElegirColeccion, onElegirListas, onCerrar }) {
  return (
    <div
      onClick={onCerrar}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(26,58,92,0.55)', zIndex: 1250,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Elegir de donde traer el producto"
        style={{
          background: '#fff', borderRadius: 14, width: '100%', maxWidth: 460,
          fontFamily: PP, color: COLOR_GRIS, padding: 24, maxHeight: '92vh', overflowY: 'auto',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: COLOR_OSCURO }}>
              ¿De donde quieres traer el producto?
            </div>
            <div style={{ fontSize: 13, color: COLOR_GRIS, marginTop: 2 }}>
              Elige la fuente para agregar a esta cotizacion.
            </div>
          </div>
          <button
            type="button"
            onClick={onCerrar}
            aria-label="Cerrar"
            style={{
              flexShrink: 0, background: 'transparent', border: 'none', cursor: 'pointer',
              color: COLOR_GRIS_CLARO, padding: 4, display: 'inline-flex',
            }}
          ><X size={20} strokeWidth={2} /></button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <OpcionOrigen
            icono={Store}
            titulo="La Tienda"
            descripcion="Busca en todo el catalogo (Syscom + Beep)"
            onElegir={onElegirTienda}
          />
          <OpcionOrigen
            icono={Layers}
            titulo="Una coleccion"
            descripcion="Trae productos de una coleccion guardada"
            onElegir={onElegirColeccion}
          />
          <OpcionOrigen
            icono={Lock}
            titulo="Listas pactadas"
            descripcion="Trae productos con precio pactado"
            onElegir={onElegirListas}
            proximamente={!onElegirListas}
          />
        </div>
      </div>
    </div>
  );
}
